import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { useHistory } from 'react-router-dom';

import { SCHEMAS } from 'js/api';

import { logout } from 'js/actions/account-actions';
import {
  Header,
  Footer,
  GlobalMessages,
  DashboardPageErrorBoundary,
} from 'js/components';
import Sidebar from './Sidebar';
import { selectActiveWorkspace } from 'js/store/reducers/workspaces';

function MinimalDashboard({
  logout,
  component: Component,
  children,
  ...props
}) {
  const history = useHistory();
  const { me } = props;

  const handleLogout = useCallback(() => {
    logout();
    history.push('/');
  }, [history, logout]);

  return (
    <div className="wrapper">
      <Sidebar me={me} />
      <div className="main-panel">
        <GlobalMessages {...props} />
        <Header {...props} onLogout={handleLogout} />
        <DashboardPageErrorBoundary layoutName="MinimalDashboard">
          {Component ? <Component {...props}>{children}</Component> : children}
        </DashboardPageErrorBoundary>
        <Footer fluid />
      </div>
    </div>
  );
}

export default connect(
  (state) => {
    const { entities } = state;

    return {
      me: denormalize(state.identity.me, SCHEMAS.ME, entities),
      activeAccount: state.activeAccount,
      activeWorkspace: selectActiveWorkspace(state),
    };
  },
  { logout }
)(MinimalDashboard);
